import { render, staticRenderFns } from "./PromocodeGroupDialog.vue?vue&type=template&id=2e3a1953&scoped=true"
import script from "./PromocodeGroupDialog.vue?vue&type=script&lang=js"
export * from "./PromocodeGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./PromocodeGroupDialog.vue?vue&type=style&index=0&id=2e3a1953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a1953",
  null
  
)

export default component.exports